import styled from 'styled-components';
import { Link as RouterLink, LinkProps as rrdLinkProps } from 'react-router-dom';
import React from 'react';
import { TinkFontSizes, TinkPaletteColors } from '../../providers/ThemeProvider/theme';

interface Props extends rrdLinkProps {
  bold?: boolean;
  color?: TinkPaletteColors;
  fontSize?: TinkFontSizes;
}

export const Link = styled(({ bold, ...rest }) => <RouterLink {...rest} />)<Props>`
  font-size: ${(props) => (props.fontSize ? props.theme.sizes[props.fontSize] : 'inherit')};
  font-weight: ${(props) => (props.bold ? props.theme.font.weights.semiBold : 'inherit')};
  color: ${(props) =>
    props.color ? props.theme.palette[props.color].main : props.theme.palette.secondary.main};
  text-decoration: none;

  &:hover {
    color: ${(props) => {
      const color = props.color || 'secondary';

      return props.theme.palette[color][800];
    }};
  }
`;
